import { type ModuleWithProviders } from '@angular/core';
import { type EffectsFeatureModule, EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FilesEffects } from './files/files.effects';
import { reducers } from './reducers';

export const UPLOADER_STATE_MODULE_CONFIG: ModuleWithProviders<EffectsFeatureModule>[] = [
  StoreModule.forFeature('uploader', reducers),
  EffectsModule.forFeature([FilesEffects]),
];
